import { render, staticRenderFns } from "./KnownCustomers.vue?vue&type=template&id=d3fdc098&"
import script from "./KnownCustomers.vue?vue&type=script&lang=js&"
export * from "./KnownCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports